import { Controller } from '@hotwired/stimulus';
import { fireChangeEvent } from '../../utils/accordion_change';
import { applyServerValue } from '../../utils/select/native_select';

export default class YearMonthPickerController extends Controller {
  static targets = ['year', 'month'];
  static values = { serverYear: String, serverMonth: String };

  connect() {
    fireChangeEvent(this.element, this._getDisplayText());
  }

  onFormReset(event) {
    if (!event.target.contains(this.element)) {
      return;
    }

    applyServerValue(this.yearTarget, this.serverYearValue);
    applyServerValue(this.monthTarget, this.serverMonthValue);
    fireChangeEvent(this.element, this._getDisplayText());
  }

  onYearChange() {
    if (this.yearTarget.value && !this.monthTarget.value) {
      this.monthTarget.selectedIndex = 1;
    } else if (!this.yearTarget.value && this.monthTarget.value) {
      this.monthTarget.value = '';
    }

    fireChangeEvent(this.element, this._getDisplayText());
  }

  onMonthChange() {
    if (!this.yearTarget.value && this.monthTarget.value) {
      this.yearTarget.selectedIndex = 1;
    } else if (this.yearTarget.value && !this.monthTarget.value) {
      this.yearTarget.value = '';
    }

    fireChangeEvent(this.element, this._getDisplayText());
  }

  _getDisplayText() {
    const year = this.yearTarget.value;
    const month = this.monthTarget.value;

    return year && month ? `${year}-${month}` : '';
  }
}
